export type ErrorTone = "lost" | "locked" | "busy" | "broken";

export type HttpErrorStatus =
  | 400
  | 401
  | 403
  | 404
  | 408
  | 409
  | 410
  | 422
  | 429
  | 500
  | 502
  | 503
  | 504;

export const ERROR_STATUSES = [
  400,
  401,
  403,
  404,
  408,
  409,
  410,
  422,
  429,
  500,
  502,
  503,
  504,
] as const satisfies readonly HttpErrorStatus[];

export const ERROR_TONE_BY_STATUS: Record<HttpErrorStatus, ErrorTone> = {
  400: "lost",
  401: "locked",
  403: "locked",
  404: "lost",
  408: "busy",
  409: "busy",
  410: "lost",
  422: "lost",
  429: "busy",
  500: "broken",
  502: "broken",
  503: "busy",
  504: "busy",
};

export function isKnownErrorStatus(status: number): status is HttpErrorStatus {
  return ERROR_STATUSES.includes(status as HttpErrorStatus);
}

export function normalizeErrorStatus(status: number): HttpErrorStatus {
  if (isKnownErrorStatus(status)) return status;
  return status >= 400 && status < 500 ? 400 : 500;
}

export function getErrorStatusFromUnknown(error: unknown): HttpErrorStatus {
  if (!error || typeof error !== "object") return 500;
  const candidate =
    "status" in error && typeof error.status === "number"
      ? error.status
      : "statusCode" in error && typeof error.statusCode === "number"
        ? error.statusCode
        : undefined;
  return typeof candidate === "number" ? normalizeErrorStatus(candidate) : 500;
}
